export default "__VITE_ASSET__BdUmih9$__"